import { IReleaseDate } from '@/types/IRelease'
import classNames from 'classnames'
import { useReleaseInfo } from 'hooks/useReleaseInfo'
import useTranslation from 'next-translate/useTranslation'
import { PropsWithClassName } from 'types'

type Props = {
  releaseDate?: IReleaseDate
  raffle?: boolean
} & PropsWithClassName

export const ReleaseInfoTag = ({ releaseDate, className, raffle }: Props) => {
  const { t } = useTranslation('release_calendar')
  const { releaseText } = useReleaseInfo(releaseDate, raffle)

  if (!releaseText) return null

  return (
    <div
      className={classNames(
        'flex h-max w-max items-center space-x-1 rounded-full px-2 py-1 text-xs',
        [t('common:released'), t('common:live')].includes(releaseText)
          ? 'bg-danger-dark text-cool-50'
          : 'bg-cool-50',
        className
      )}
    >
      <span>{releaseText}</span>
    </div>
  )
}
